import { setGetAuthTokenModule, setRefreshTokensModule } from '@quickmd-llc/frontend-utils'
import { postAuthRefreshtoken } from './generated/auth/auth'
import { store } from '../app/store'
import { LOGOUT, REFRESH_TOKEN_SUCCESS } from '../app/authState'

const getAuthToken = () => store.getState().auth.accessToken

const refreshTokens = async () => {
  try {
    const authToken = getAuthToken()
    const response = await postAuthRefreshtoken({ AccessToken: authToken })
    if (response.AccessToken) {
      store.dispatch({ type: REFRESH_TOKEN_SUCCESS, payload: { AccessToken: response.AccessToken } })
      return true
    }
    return false
  } catch {
    store.dispatch({ type: LOGOUT })
    return false
  }
}

export function initOrvalTokenModules() {
  setGetAuthTokenModule(getAuthToken)
  setRefreshTokensModule(refreshTokens)
}
